Auth = require 'db/auth'
Controller = require 'controller'
ModelLoader = undefined
queueRequire -> ModelLoader = require 'db/model-loader'
ReactionList = require 'models/collections/reaction-list'
TrelloModel = require 'models/internal/trello-model'
Util = require 'lib/util'
_ = require 'underscore'
xtend = require 'xtend'

module.exports = class Notification extends TrelloModel
  @PAGE_SIZE: 10
  typeName: 'Notification'
  urlRoot: '/1/notifications'

  initialize: ->
    @reactionList = new ReactionList([]).syncCache @modelCache, [], (reaction) =>
      # Sometimes @get('idAction') is being called on a model that has already
      # been deleted (when a reaction has been added to an already read
      # notification, which is deleted and created anew to maintain the
      # correct order in the notification pane). This doesn't cause any
      # problems for the user, but does throw errors in the console.
      try
        reaction.get('idModel') == @get('idAction')
      catch err
        return

  @sortedByDateDescending: (modelCache) ->
    _.sortBy modelCache.all('Notification'), (notification) ->
      -(new Date(notification.get('date'))).getTime()

  getModel: -> @collection.options.model

  getBoard: ->
    if (idBoard = @get('data')?.board?.id)?
      @modelCache.get 'Board', idBoard
    else
      null

  getCard: ->
    if (idCard = @get('data')?.card?.id)?
      @modelCache.get 'Card', idCard
    else
      null

  getMember: ->
    @modelCache.get('Member', @get('idMemberCreator'))?.toJSON()

  getMemberReactorsFullNames: ->
    idMembersReacted =
      @reactionList.chain()
        .map (model) => model.get('idMember')
        .flatten()
        .unique()
        .map (id) => @modelCache.get('Member', id).get('fullName')
        .value()

  triggerCacheEvents: (modelCache, event) ->
    for idModel in @idModels()
      modelCache.trigger "#{ event }:#{ @typeName }:#{ idModel }"
    return

  idModels: -> (value.id for key, value of (@get('data') ? {}) when value?.id?)

  isCommentLike: ->
    @get('type') in ['commentCard', 'copyCommentCard', 'mentionedOnCard'] ||
        (@get('type') == 'reactionAdded' && @get('data')['actionType'] == 'commentCard')

  isAddAttachment: ->
    @get('type') == 'addAttachmentToCard'

  getExpandedData: ->
    data = xtend (@toJSON().data ? {}),
      date: @get('date')
      dateRead: @get('dateRead')
      unread: @get('unread')

    data[@get('type')] = true

    { board, card, organization } = data

    data

  markRead: ->
    @update({ unread: false })

  toggleRead: ->
    @update({ unread: !@get('unread') })

  shouldScrollToHash: ->
    # the types of notifications that should append the action hash
    @isCommentLike()

  shouldGenerateActionLink: ->
    @shouldScrollToHash() || @get('type') in [
      'changeCard',
      'createdCard',
      'addAttachmentToCard',
      'addedToCard',
      'removedFromCard',
      'cardDueSoon'
    ]

  getActionHash: ->
    if @get('idAction') && @shouldScrollToHash()
      prefix =
        if @isCommentLike()
          'comment'
        else
          'action'
      [prefix, @get('idAction')].join('-')

  getCardShortUrl: ->
    card = @get('data')?.card
    "/c/#{card.shortLink}/#{card.idShort}-#{Util.makeSlug(card.name)}"

  getActionLink: ->
    if @shouldGenerateActionLink()
      actionHash = @getActionHash()
      if @getCard()?.get('url')
        Controller.getCardUrl(
          @getCard(),
          actionHash
        )
      else if @get('data')? && @get('data')?.card?
        [@getCardShortUrl(), actionHash].join('#')

  getUrlOfTarget: ->
    data = @get('data')
    if data.enterprise? && Auth.me().isEnterpriseAdminOf(data.enterprise)
      Controller.getEnterpriseAdminDashboardUrl(data.enterprise.id)
    else if data.card?
      Controller.getCardUrlWithoutModels(
        data.board.id
        data.card.id
        data.card.name
      )
    else if data.board?
      Controller.getBoardUrl(data.board)
    else if data.organization?
      # use org.id since name has funky capitalization issues
      Controller.getOrganizationUrl(data.organization.id)



// WEBPACK FOOTER //
// ./app/scripts/models/notification.coffee